export const HOME_URL = process.env.PUBLIC_URL